import { Component } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

interface Testimonial {
  key: 'unique' | 'maher';
  photo: string;
  initials: string;
  accent: string;
  accentSoft: string;
  videoUrl?: string;
}

/**
 * Partner & candidate testimonials.
 * Photos live in src/assets/testimonials/. Until sylvia.jpg / maher.jpg are
 * added there, each card gracefully falls back to an initials avatar.
 */
@Component({
  selector: 'app-landing-testimonials',
  standalone: true,
  imports: [NgForOf, NgIf, TranslateModule],
  templateUrl: './landing-testimonials.component.html',
  styleUrls: ['./landing-testimonials.component.scss'],
})
export class LandingTestimonialsComponent {
  readonly testimonials: Testimonial[] = [
    { key: 'unique', photo: 'assets/testimonials/sylvia.png', initials: 'SH', accent: '#E26E14', accentSoft: '#FCEFE2' },
    { key: 'maher', photo: 'assets/testimonials/maher.jpg', initials: 'MA', accent: '#D42020', accentSoft: '#FBEAE8', videoUrl: 'https://www.instagram.com/p/DZo_Da1sYV6/' },
  ];

  failedPhoto: Record<string, boolean> = {};

  onError(key: string): void {
    this.failedPhoto[key] = true;
  }
}
